import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { RootState } from "../../../../app/store";
import {
  selectAll,
  useRemoveCategoryMutation
} from "../../api/categoryApiSlice";
import CategoryListPresentation from "../../presentation/categroy.list.presentation/category.list.presentation";
import { Category, CategoryListContainerProps } from "../../types/types";

import { useLazyGetAllSubCategoryByCategoryIdQuery } from "../../../subcategory/api/subCategoryApiSlice";
import { changeSubCategoryStatus } from "../../../subcategory/subCategorySlice/subCategorySlice";
import {
  changeSelectCategoryId,
  changeSelectCategoryStatus,
} from "../../categorySlice/categorySlice";
const CategoryListContainer: React.FC<CategoryListContainerProps> = ({
  projectId
}) => {
  const [getAllSubCategoryByCategoryId, 
  //  { isLoading, isError }
  ] =
    useLazyGetAllSubCategoryByCategoryIdQuery();
  const [
    removeCategory,
    // {
    //   isLoading: removeLoading,
    //   isError: removeError,
    //   isSuccess: removeSuccess,
    // },
  ] = useRemoveCategoryMutation();
  const dispatch = useAppDispatch();
  const categories = useAppSelector((state: RootState) =>
    selectAll(state, projectId)(state)
  )

  const selectCategoryHandler = async (item: Partial<Category>) => {
    try {
      await getAllSubCategoryByCategoryId(item._id!);
      dispatch(changeSelectCategoryId(item._id));
      dispatch(changeSelectCategoryStatus(true));
      dispatch(changeSubCategoryStatus(false));
    } catch (error) {
      console.error(error)
    }
  };

  const selectCategoryRemoveHandler = async (item: Partial<Category>) => {
    await removeCategory(item._id!)
  }

  return (
    <CategoryListPresentation
      categories={categories}
      selectCategoryHandler={selectCategoryHandler}
      selectCategoryRemoveHandler={selectCategoryRemoveHandler}
    />
  )
}

export default CategoryListContainer
